import * as PIXI from "pixi.js";
import { Color, LogGroup, Rect, Size } from "../.././MyHelpers";
import { LineWin, PlayWindow } from "../../api";
import { ISystemContext } from "../../Context/SystemContext";
import { ResourceIdentifier } from "../../ResourceManager/ResourceIdentifier";
import { IReadOnlyResourceManager, IWriteOnlyResourceManager } from "../../ResourceManager/ResourceManager";
import { ISpinnableReels } from "../SpinAnimation/SpinnableReels";
import { MarkersInfoColors } from "../WinLineInfoMarkers";

export interface WinLinesAnimationParams {
	readonly viewSize: Size;
	readonly spinnableReels: ISpinnableReels;
	readonly lines: number[][];
	readonly logGroup: LogGroup;
	readonly resid: ResourceIdentifier;
	readonly systemContext: ISystemContext;
	readonly slotWindow: Rect,
	readonly slotWindowSymbolSize: PlayWindow,
	readonly colorLineMarkers : MarkersInfoColors,
	readonly speedFactorAnimation: number
	readonly gameName : string ,
	readonly winLinesTypeStyle : WinLinesTypeStyle,
}

export enum WinLinesTypeStyle {
	default = "default",
	gameStyle = "gameStyle",
}

export enum WinLinesDrawOrder {
	frontSymbols = "frontSymbols",
	backSymbols = "backSymbols",
}


export type WinLinesAnimationCompleteCallback = (interrupted: boolean) => void;
export type WinLinesAnimationNewLineCallback = (line: LineWin, color: Color, animateOnlyWinningSymbols: boolean) => void;
export type WinLinesAnimationStartLineCallback = (line: LineWin, color: Color, animateOnlyWinningSymbols: boolean) => void;

export abstract class GenericWinLinesAnimation 
{
	protected completeCallbacks: WinLinesAnimationCompleteCallback[] = [];
	protected nextLineCallbacks: WinLinesAnimationNewLineCallback[] = [];
	protected interrupted: boolean;

	public abstract PrepareResources(resourceManager: IWriteOnlyResourceManager): Promise<void>;
	public abstract ResourcesLoaded(resourceManager: IReadOnlyResourceManager): Promise<void>;

	public abstract Start(resultLines: LineWin[], duration: number): void
	public abstract GetDuration(): number;
	public abstract Update(): void;
	public abstract RequestStop(): void;

	public AddCompleteCallbacks(callback: WinLinesAnimationCompleteCallback): void {
		this.completeCallbacks.push(callback);
	}
	public AddNextLineCallback(callback: WinLinesAnimationNewLineCallback): void {
		this.nextLineCallbacks.push(callback);
	}
	protected OnComplete(interrupted: boolean = false): void {
		//// Log.Debug(this.logGroup, "Complete");
		for (let i = 0; i < this.completeCallbacks.length; i++) {
			this.completeCallbacks[i](interrupted);
		}
	}
	protected OnNextLine(line: LineWin, color: Color, animateOnlyWinningSymbols: boolean): void {
		for (let i = 0; i < this.nextLineCallbacks.length; i++) {
			this.nextLineCallbacks[i](line, color, animateOnlyWinningSymbols);
		}


	}

	protected startLineCallbacks: WinLinesAnimationStartLineCallback[] = [];
	protected OnStartLine(line: LineWin, color: Color, animateOnlyWinningSymbols: boolean): void {
		for (let i = 0; i < this.startLineCallbacks.length; i++) {
			this.startLineCallbacks[i](line, color, animateOnlyWinningSymbols);
		}
	}

	public AddStartLineCallback(callback: WinLinesAnimationStartLineCallback): void {
		this.startLineCallbacks.push(callback);
	}

	public abstract View(): HTMLElement;

}

export abstract class GenericWinLinesAnimationPIXIAPP extends GenericWinLinesAnimation 
{
	public abstract ViewPIXIAPP(): PIXI.Container;
	public abstract CreatePIXIAPP(containerPIXI? : PIXI.Container);
}